import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { CustomReportsService } from '@/infra/services/custom-reports';

interface GetCustomReportsParams {
	organization_id: string;
	company_id?: string;
}

const Service = CustomReportsService.getInstance();

export const useGetCustomReports = (params: GetCustomReportsParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_CUSTOM_REPORTS],
		queryFn: () => Service.findAll(params)
	});
};
